<script setup>
import {
  formatSocialRate,
  normalizeSocialRatePercent,
  socialRateBarWidth,
} from '@/utils/socialRate';

defineProps({
  dayRate: { type: Number, default: null },
  weekRate: { type: Number, default: null },
});

const rateColor = (value) => {
  const n = normalizeSocialRatePercent(value);
  if (n == null) return 'var(--text-secondary)';
  if (n > 0) return 'var(--accent-green)';
  if (n < 0) return 'var(--accent-pink)';
  return 'var(--text-secondary)';
};
</script>
<template>
  <div class="detail-row">
    <span class="detail-label">前日比</span>
    <div class="detail-bar-container">
      <div
        class="detail-bar"
        :style="{ width: `${socialRateBarWidth(dayRate)}%`, background: rateColor(dayRate) }"
      />
    </div>
    <span class="detail-value" :style="{ color: rateColor(dayRate) }">{{ formatSocialRate(dayRate) }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">週間</span>
    <div class="detail-bar-container">
      <div
        class="detail-bar"
        :style="{ width: `${socialRateBarWidth(weekRate)}%`, background: 'var(--accent-blue)' }"
      />
    </div>
    <span class="detail-value" style="color: var(--accent-blue);">{{ formatSocialRate(weekRate) }}</span>
  </div>
</template>
